import axios from 'axios'

function removeUndefined(obj) {
  Object.keys(obj).forEach((key) => {
    if ((obj[key] === undefined) || (obj[key] === "")) {
      delete obj[key]
    }
  });
  return obj
}

function downloadFromS3(url) {
  const a = document.createElement('a');
  a.href = url;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

function downloadFile(url, file, type, params) {
  const options = {
    headers: {'accept': type},
    responseType: 'blob',
    params
  };

  return axios.get(url, options).then(response => {
    const blob = new Blob([(response.data)], {type: type});
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.id = 'tmp-file-download';
    anchor.setAttribute('download', file);
    document.body.appendChild(anchor);
    anchor.click();
    document.getElementById(anchor.id).remove();
  })
    .catch(error => {
      console.error('Error downloading the file:', error);
    });
}

export default {
  statistics: (params) => axios.get(`/api/statistics`, { headers: {Accept: 'text/json'}, params: removeUndefined(params)}),
  statisticsCsv: (params) => downloadFile(`/api/statistics`, 'Monitoraggio Negozi.csv', 'text/csv', removeUndefined(params)),
  membershipList: (params) => axios.get('/api/memberships/search/previews', {headers: {Accept: 'text/json'}, params: removeUndefined(params) }),
  downloadCsv: (startDate, endDate) => axios.get(`/api/V2/memberships`, {headers: {Accept: 'text/csv'}, params: {startDate, endDate}}),
  downloadRefreshCampaignCsv: (startDate) => downloadFile(`/api/refresh-campaign`, 'campagna.csv', 'text/csv', {startDate}),
  downloadCountRefreshCampaignCsv: (startDate) => downloadFile(`/api/count-refresh-campaign`, 'conteggio.csv', 'text/csv', {startDate}),
  delete: (id) => axios.delete('/api/memberships/' + id),
  postMembershipToDitech: (contractCode) => axios.post(`/api/memberships/${contractCode}/ditech`),
  findBy: (id) => axios.get('/api/memberships/' + id),
  update: (id, fields) => axios.patch(`api/memberships/${id}`, fields),
  fileDownload: (url) => downloadFromS3(url)
}
